import React, {useState, useEffect, useRef} from 'react';
import {Tooltip} from "primereact/tooltip";
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {ConfirmDialog} from "primereact/confirmdialog";
import {addLocale, locale} from "primereact/api";
import {InputText} from "primereact/inputtext";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import {Badge} from "primereact/badge";

const _FM_BerthListComponent = (props) => {
  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [berth, setBerth] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('berth_first')) || 0,
    rows: Number(localStorage.getItem('berth_rows')) || rows,
    page: Number(localStorage.getItem('berth_page')) || 0,
    sortField: localStorage.getItem('berth_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('berth_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('berth_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "berth" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setBerth(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', berthSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', berthSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-mr-2"
                tooltip={t('show')}
                tooltipOptions={{position: 'left'}}
                disabled={rowData.deleted_at_snapshot}
                onClick={() => {
                  navigate('/berth/read/' + rowData.id)
                }}/>
        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-mr-2"
                tooltip={t('edit')}
                tooltipOptions={{position: 'left'}}
                disabled={rowData.deleted_at_snapshot}
                onClick={() => {
                  navigate('/berth/update/' + rowData.id)
                }}/>
        {rowData && rowData.deleted_at_snapshot ? (
          <Button icon="pi pi-undo" className="p-button-sm p-button-success"
                  tooltip={t('restore')}
                  tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    axios({
                      method: 'get',
                      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "berth/" + rowData.id + "/restore",
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + Cookies.get("userToken"),
                        "Sys-name": Cookies.get("instanceId"),
                        "Preferred-locale": Cookies.get("language")
                      }
                    })
                      .then(response => {
                        window.App.toastShow('success', t('success_restore'),);
                        loadLazyData();
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                  }}
          />
        ) : (
          <>
            <Button icon="pi pi-trash" className="p-button-sm  p-button-danger"
                    tooltip={t('delete')}
                    tooltipOptions={{position: 'left'}}
                    onClick={() => {
                      window.App.setState({[`confirmDelete${rowData.id}`]: true})
                    }}
            />
            <ConfirmDialog group="declarative" visible={window.App.state[`confirmDelete${rowData.id}`]}
                           acceptLabel={t('yes')} rejectLabel={t('no')}
                           onHide={() => {
                             window.App.setState({[`confirmDelete${rowData.id}`]: false})
                           }}
                           message={t('confirm_delete')} header={t('confirm_delete')} icon="pi pi-exclamation-triangle"
                           accept={() => {
                             window.App.delete('berth', rowData.id)
                               .then(response => {
                                 window.App.toastShow('success', t('success_delete'),);
                                 loadLazyData();
                               })
                               .catch(error => {
                                 window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                               })
                           }}
                           reject={() => {
                             window.App.setState({[`confirmDelete${rowData.id}`]: false})
                           }}/>
          </>
        )}
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('berth_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('berth_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('berth_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('berth_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('berth_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('berth_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderBerthList, window.App.state.rerenderUnitList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('berth_list')}</h2>
        </div>
        <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
          <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
          {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
            <Button type="button"
                    label={t('accommodation_import')}
                    icon={"pi pi-upload"}
                    onClick={() => {
                      navigate('/berth/all/import/accommodation')
                    }}
                    className="p-button-secondary p-ml-2"/>
          }
          {localStorage.getItem('berth_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('berth_filters')
                 localStorage.removeItem('berth_sortField')
                 localStorage.removeItem('berth_sortOrder')
                 localStorage.removeItem('berth_rows')
                 localStorage.removeItem('berth_page')
                 localStorage.removeItem('berth_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          {lazyParams && lazyParams.is_active === 0 ? (
            <Button type="button" icon={"pi pi-eye-slash"}
                    label={t('hide_deleted')}
                    onClick={() => {
                      let _lazyParams = lazyParams
                      delete lazyParams.is_active
                      setLazyParams(_lazyParams)
                      loadLazyData()
                    }}
                    className="p-button-danger p-ml-2"/>
          ) : (
            <Button type="button" icon={"pi pi-eye"}
                    label={t('show_deleted')}
                    onClick={() => {
                      setLazyParams({
                        ...lazyParams,
                        is_active: 0
                      })
                    }}
                    className="p-button-success p-ml-2"/>
          )}
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('berth_filters')
                             localStorage.removeItem('berth_sortField')
                             localStorage.removeItem('berth_sortOrder')
                             localStorage.removeItem('berth_rows')
                             localStorage.removeItem('berth_page')
                             localStorage.removeItem('berth_first')
                             setLazyParams({
                               ...lazyParams,
                               filters: null,
                               genericSearch: e.target.value
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
          <Button type="button" label={t('new_berth')} icon={"pi pi-plus"}
                  onClick={() => {
                    navigate('/berth/create')
                  }}
                  className="p-button-success p-ml-2"/>
        </div>
      </div>
      {/* <HelpComponent type={"list_box"} box={"berth"}/> */}
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={berth} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if(!rowData.data.deleted_at_snapshot)
            navigate('/berth/update/' + rowData.data.id)
        }}
      >
        
        <Column field="name" sortable header={t('name')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        <Column field="accommodation.name" sortable header={t('accommodation')}
                body={(rowData) => <><span className={"p-text-nowrap"}>{rowData?.accommodation?.name}<span className={"tt-auto-invoice p-ml-2"} data-pr-tooltip={rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? t('auto_invoice_tooltip_active') : t('auto_invoice_tooltip_inactive')}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"auto-invoice-icon"} style={{ color: rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? '#0abb87' : '#dddddd', position: 'relative', bottom: '-3px' }}><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8" /><path d="M5 21l2.5-1.5L10 21l2.5-1.5L14 21l1.5-1" /><path d="M9 7h6" /><path d="M9 11h4" /><path d="M18 14a3 3 0 1 0 3 3" /><path d="M21 20v-3h-3" /></svg></span></span><Tooltip target=".tt-auto-invoice"/></>}
        ></Column>
        <Column field="residential_unit.name" header={t('residential_unit')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                filterField={"residential_unit.name"}
                body={(rowData) => {
                  return (
                    <>
                      <i className={"pi pi-window-maximize"}
                         onClick={(e) => {
                           navigate('/berth?update=unit&unitId=' + rowData.residential_unit.id)
                         }}
                      ></i>
                      &nbsp;
                      {rowData.residential_unit.name}
                        {/*{rowData?.residential_unit?.is_ready === true ? (*/}
                        {/*  <Badge severity="success" style={{height: '8px', width: '8px', minWidth: '8px', position: 'relative', top: '-5px', left: '5px'}}></Badge>*/}
                        {/*) : (*/}
                        {/*  <Badge severity="danger"  style={{height: '8px', width: '8px', minWidth: '8px', position: 'relative', top: '-5px', left: '5px'}}></Badge>*/}
                        {/*)}*/}
                    </>
                  )
                }}
        ></Column>
        <Column field="created_at_snapshot" sortable header={t('created_at')}
                filter
                filterField={"created_at"}
                sortField={"created_at"}
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.created_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                filterField={"updated_at"}
                sortField={"updated_at"}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.updated_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(_FM_BerthListComponent);
